export default [{
    dictKey: '',
    dictValue: '全部'
}, {
    dictKey: '0',
    dictValue: '未知交易'
}, {
    dictKey: '1',
    dictValue: '消费'
}, {
    dictKey: '2',
    dictValue: '代付'
},

//     {
//     dictKey: '1',
//     dictValue: '认证支付',
// }, {
//     dictKey: '2',
//     dictValue: '密码支付',
// }, {
//     dictKey: '3',
//     dictValue: '刷脸支付',
// }, {
//     dictKey: '4',
//     dictValue: '扫码支付',
// }
];




// WEBPACK FOOTER //
// ./src/service/constant/OperationType.js